import { render } from "./PackageDetailTemplate.vue?vue&type=template&id=b4485514&scoped=true"
import script from "./PackageDetailTemplate.vue?vue&type=script&lang=js"
export * from "./PackageDetailTemplate.vue?vue&type=script&lang=js"

import "./PackageDetailTemplate.vue?vue&type=style&index=0&id=b4485514&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b4485514"

export default script